import { DatasetList } from './enums';

export const DatasetSidecardHeadingMapper = {
  [DatasetList.Site]: 'Select Site',
  [DatasetList.Iteration]: 'Select Iteration',
  [DatasetList.Layer]: 'Select Layers',
};
